import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { buildInvoiceText } from '../../../utils/invoiceText';

type Props = {
  organizationName: string;
  registrationNumber?: string | null;
};

/**
 * How the order gets paid, inline at the foot of the order card rather than as a
 * banner above it — it is a property of the order, not a warning about it.
 * Neutral `muted` fill: a brand wash here competes with the card's own actions.
 */
export const StationaryInvoiceNotice = ({ organizationName, registrationNumber }: Props) => (
  <div className='flex items-start gap-2 rounded-lg bg-muted p-4'>
    {/* 16px icon nudged to the middle of the title's 24px line box, as in NoddiInfoBanner. */}
    <NoddiIcon name='CreditCard' className='mt-1 shrink-0' />
    <div className='flex min-w-0 flex-col gap-1'>
      <span className='font-semibold'>
        <Trans>Paid by invoice</Trans>
      </span>
      <span className='text-sm'>{buildInvoiceText(organizationName, registrationNumber)}</span>
    </div>
  </div>
);
